<section id="mainSection">
  <div class="textContainer">
    <h1>Herzlich Willkommen!</h1>
    <p>
      Im letzten Jahrhundert haben mein Urgroßvater Fritz Kempe und sein Cousin
      Klaas Kempe gemeinsam mit Isa Ramm ausführliche Ahnenforschung betrieben
      und sehr viele Daten zusammengetragen. In den 1980er Jahren hat mein
      Großvater Sigismund Eberhard die Stammfolge Kempe beim ostfriesischen
      Geschlechterbuch eingereicht, wo sie im Band 6 veröffentlicht wurde
      (dessen Redaktion er auch übernahm, und welches unter anderem auch die von
      Isa eingereichte Stammfolge Tannen beinhaltet).
    </p>
    <p>
      Im Jahr 2022 bin ich bei der Recherche zu einem anderen Projekt wieder
      über unseren ausführlichen Stammbaum gestolpert. Das Buch ist mittlerweile
      vergriffen, den Verlag gibt es nicht mehr. So entstand die Idee, die Daten
      zu digitalisieren und neu aufzubereiten, damit die Arbeit unserer Ahnen
      nicht einfach verloren geht. Bei persönlichen Gesprächen habe ich dies
      bereits mit vielen von euch besprochen - und hier ist sie: Die
      Familienseite der ostfriesischen Familie Kempe und ihrer Verwandten.
    </p>
    <p>
      Ihr findet hier den
      <a routerLink="/ancestors" routerLinkActive="active">Stammbaum</a>,
      allerdings nur zum Lesen und nicht zum Bearbeiten. In der Übersicht könnt
      ihr die verschiedenen Äste und Zweige sehen - wenn ihr auf die Namen
      klickt, führen sie euch zu der jeweiligen Person. Da beim Stammbaum wohl
      einige Fehler vorhanden sind, gibt es auch eine personenbezogene
      <a routerLink="/discussions" routerLinkActive="active">Diskussionseite</a
      >. Wenn ihr einen Fehler entdeckt, klickt auf den entsprechenden Button
      und eröffnet eine neue Diskussion zu dieser Person oder nehmt an der
      existierenden Diskussion teil. Gerne könnt ihr hier auch Fotos hochladen,
      die wir dann in die Datenbank überführen. Bei jeder Person sind bis zu
      sechs Fotos möglich, bei einem Beitrag bis zu vier.
    </p>
    <b
      >Ganz neu ist jetzt eine Seite zum Bearbeiten des Stammbaums - wenn ihr
      daran Interesse habt und Personen eintragen oder bearbeiten wollt,
      schreibt mir bitte, damit ich euch freischalten und eine kleine Einführung
      geben kann.</b
    >
    <p>
      Daneben stellen wir euch einen
      <a routerLink="/faminfos" routerLinkActive="active">Infoblog</a> bereit,
      in dem jeder von euch Einträge zu mehreren oder unabhängig von einer
      bestimmten Person machen kann. Bitte beachtetet bei jeder Seite auch die
      entsprechenden Hinweise.
    </p>
    <p>
      Und da es auch einiges an sehr leckeren
      <a routerLink="/recipes" routerLinkActive="active">Familienrezepten</a>
      gibt, wollen wir euch hier auch die Möglichkeit geben, sie mit der Familie
      zu teilen.
    </p>
    <p>
      Eure Kontodaten ändern und einsehen könnte ihr
      <a routerLink="/account" routerLinkActive="active">hier</a>
      und falls ihr Anregungen zur Webseite habt oder ihren Aufbau diskutieren
      wollt, haben wir eine Seite für die
      <a routerLink="/infos" routerLinkActive="active"
        >Diskussion zur Webseite</a
      >.
    </p>
    <p>
      Solltet ihr weitere Ideen, Anregungen oder Sorgen diesbezüglich haben,
      kontaktiert mich gerne. Meine E-mail findet ihr im Impressum.
    </p>
    <p>Viel Spaß!</p>
    <p>Anne Eberhard</p>
  </div>
</section>
<app-scroll-to-top-button></app-scroll-to-top-button>
